<template>
    <div class="menulist">
        <h2 class="title" v-text="'Opções'"></h2>
        <div class="menulist-container">
            <div class="menulist-item" v-for="(cItem, cKey) in homeMenuListItens" :key="cKey" @click="emitEvent(cItem)"
                v-permission="cItem.permission">
                <div v-for="(fItem, fKey) in fieldMap.filter(f => f != 'action')" :key="fKey">
                    <i v-if="fItem == 'icon'" :class="`fa fas ${cItem[fItem]}`"></i>
                    <span v-else-if="fItem == 'balance'" v-text="cItem[fItem]"></span>
                    <h3 v-else v-text="cItem[fItem]"></h3>
                </div>
            </div>
        </div>
    </div>
</template>
<script >
export default {
    name: 'MenuListComponent',
    props: ['homeMenuListItens', 'fieldMap', 'menuVis'],
    methods: {
        emitEvent: function (cItem) {
            this.$emit('componentEvent', cItem)
        }
    }
}
</script>
<style lang="less" scoped>
.menulist {
    position: relative;
    margin: 25px -15px 0 -15px;
    user-select: none;
    .title {
        margin: 0;
        font-weight: normal;
        font-size: 1.5rem;
        padding: 0 0 0 15px;
    }
    .menulist-container {
        margin: 10px 0 0 0;
        position: relative;
        height: calc(100vh - 375px);
        overflow-y: auto;
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 7.5px));
        grid-column-gap: 15px;
        grid-row-gap: 15px;
        padding: 0 15px 15px 15px;
        .menulist-item {
            position: relative;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-evenly;
            align-items: center;
            min-height: 90px;

            border-radius: 5px;
            border: 1px solid var(--cardBorder);
            background: var(--cardBackground);
            box-shadow: 2px 2px 4px 0px var(--cardBorder);
            transition: all linear .2s;

            i {
                font-size: 1.5rem;
                color: var(--iconColor);
            }
            &:active{
                box-shadow: 0 0 0 0 var(--cardBorder);
            }
        }
    }
}
</style>
